import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./ShortTermMemoryGame.css";

const ShortTermMemoryGame = () => {

  const navigate = useNavigate();
   useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }, []);
const [level, setLevel] = useState(1);

const [sequence, setSequence] = useState([]);

const [showCards, setShowCards] = useState(true);

const [userInput, setUserInput] = useState([]);

const [page, setPage] = useState("game");

const [deck, setDeck] = useState([]);

const [deckIndex, setDeckIndex] = useState(0);

const [allResults, setAllResults] = useState([]);

const [leaderboard, setLeaderboard] = useState([]);

const [userRank, setUserRank] = useState(null);

const [showReview, setShowReview] = useState(false);

const [lastCorrect, setLastCorrect] = useState("");

const [lastUser, setLastUser] = useState("");

const [timeLeft, setTimeLeft] = useState(5);

const MAX_LEVEL = 15;

const suits = ["♠", "♥", "♣", "♦"];

const ranks = [
  "2","3","4","5","6","7","8",
  "9","10","J","Q","K","A"
];

/* ===========================
      CREATE SHUFFLED DECK
=========================== */

const createShuffledDeck = () => {

  const fullDeck = [];

  suits.forEach((suit) => {

    ranks.forEach((rank) => {

      fullDeck.push({

        rank,

        suit

      });

    });

  });

  for (

    let i = fullDeck.length - 1;

    i > 0;

    i--

  ) {

    const j = Math.floor(

      Math.random() * (i + 1)

    );

    [

      fullDeck[i],

      fullDeck[j]

    ] = [

      fullDeck[j],

      fullDeck[i]

    ];

  }

  return fullDeck;

};

/* ===========================
      INITIALIZE DECK
=========================== */

useEffect(() => {

  const shuffledDeck =

    createShuffledDeck();

  setDeck(shuffledDeck);

}, []);

/* ===========================
      START LEVEL
=========================== */

const startLevel = () => {

  const cardsNeeded =

    level + 2;

  let currentDeck = deck;

  let currentIndex = deckIndex;

  // If deck finished,
  // create a new shuffled deck

  if (

    currentIndex + cardsNeeded >

    currentDeck.length

  ) {

    currentDeck =

      createShuffledDeck();

    currentIndex = 0;

    setDeck(currentDeck);

  }

  const seq = currentDeck.slice(

    currentIndex,

    currentIndex + cardsNeeded

  );

  setDeckIndex(

    currentIndex + cardsNeeded

  );

  setSequence(seq);

  setShowCards(true);

  setUserInput([]);

  let time = 5;

  setTimeLeft(time);

  const interval = setInterval(() => {

    time--;

    setTimeLeft(time);

    if (time === 0) {

      clearInterval(interval);

      setShowCards(false);

    }

  }, 1000);

};

/* ===========================
      START GAME
=========================== */

useEffect(() => {

  if (deck.length > 0) {

    startLevel();

  }

}, [level, deck]);
  // ================= ADD INPUT =================
  const handleCardClick = (rank, suit) => {

    if (userInput.length >= sequence.length) return;

    const updated = [...userInput, { rank, suit }];
    setUserInput(updated);

    // 🔥 AUTO SUBMIT
   
  };

  // ================= SUBMIT =================
  const handleSubmit = (input = userInput) => {

  const correctString = sequence.map(c => `${c.rank}${c.suit}`).join(" ");
  const userString = input.map(c => `${c.rank}${c.suit}`).join(" ");

  const correct = correctString === userString;

  const updated = [
    ...allResults,
    {
      level,
      correctSequence: correctString,
      userInput: userString
    }
  ];

  setAllResults(updated);

  if (correct) {
    if (level === MAX_LEVEL) {
      finishGame(level, updated);
    } else {
      setLevel(prev => prev + 1);
    }
  } else {
    // 🔥 SHOW REVIEW INSTEAD OF DIRECT RESULT
    setLastCorrect(correctString);
    setLastUser(userString);
    setShowReview(true);
  }
};

  // ================= LEADERBOARD =================
  const fetchLeaderboard = async () => {
    try {
      const email = localStorage.getItem("rg_email");

      const res = await axios.get(`/shorttermleaderboard?email=${email}`);

      setLeaderboard(res.data.leaderboard || []);
      setUserRank(res.data.userRank);

    } catch (e) {
      console.log(e);
    }
  };

  // ================= FINISH =================
  const finishGame = async (finalLevel, resultsData) => {
    setShowReview(false); // 🔥 ADD THIS

    setPage("result");

    const email = localStorage.getItem("rg_email");
    const name = localStorage.getItem("rg_name") || "";

    try {
      await axios.post("/save-short-term-memory", {
        name,
        email,
        level: finalLevel,
        sessions: resultsData
      });

      await fetchLeaderboard();

    } catch (e) {
      console.log(e);
    }
  };

  // ================= UI =================
  return (
    <div className="stm-game-container">

      {page === "game" && (
        <>
          <h2 className="stm-level">
            Level {level} / {MAX_LEVEL}
          </h2>
          {showCards && (
            <h3 className="timer-text">
              {timeLeft}s
            </h3>
          )}

          {showCards ? (
            <div className="stm-card-container">
              {sequence.map((card, index) => (
                <div
                  key={index}
                  className={`stm-card ${card.suit === "♥" || card.suit === "♦" ? "red" : ""}`}
                >
                  <div className="card-top">{card.rank}{card.suit}</div>
                  <div className="card-center">{card.suit}</div>
                  <div className="card-bottom">{card.rank}{card.suit}</div>
                </div>
              ))}
            </div>
          ) : !showReview && (



            <div className="stm-input-box">

              <p>Recreate the sequence</p>

              {/* USER DISPLAY */}
              <div className="stm-user-display">
              {userInput.map((c, i) => (
                <span
                  key={i}
                  className={c.suit === "♥" || c.suit === "♦" ? "red-text" : "black-text"}
                >
                  {c.rank}{c.suit}{" "}
                </span>
                ))}
              </div>

              {/* 🔥 PERFECT ROW INPUT */}
              <div className="stm-input-grid">

                {suits.map((suit) => (
                  <div key={suit} className="suit-row">

                    <div className="suit-label">{suit}</div>

                    {ranks.map(rank => (
                      <button
                        key={rank + suit}
                        className={`card-btn 
                          ${(suit === "♥" || suit === "♦") ? "red" : ""} 
                          ${userInput.some(c => c.rank === rank && c.suit === suit) ? "selected" : ""}
                        `}
                        onClick={() => handleCardClick(rank, suit)}
                      >
                        {rank}{suit}
                      </button>
                    ))}

                  </div>
                ))}

              </div>

              {/* CONTROLS */}
              <div className="stm-controls">
                <button onClick={() => setUserInput([])}>Clear</button>
                <button onClick={() => setUserInput(prev => prev.slice(0, -1))}>
                  Undo
                </button>
                 <button 
                    className="submit-btn"
                    onClick={() => handleSubmit()}
                    disabled={userInput.length !== sequence.length}
                  >
                    Submit
                  </button>
              </div>

            </div>
          )}
        </>
      )}
     {showReview && page === "game" && (
  <div className="review-box">

    <h2>❌ Wrong Answer</h2>

    {/* YOUR ANSWER */}
    <div className="review-section">
      <h3>Your Answer</h3>

      <div className="stm-card-container">

        {userInput.map((card, index) => (
          <div
            key={index}
            className={`stm-card ${
              card.suit === "♥" || card.suit === "♦" ? "red" : ""
            }`}
          >
            <div className="card-top">
              {card.rank}{card.suit}
            </div>

            <div className="card-center">
              {card.suit}
            </div>

            <div className="card-bottom">
              {card.rank}{card.suit}
            </div>
          </div>
        ))}

      </div>
    </div>

    {/* CORRECT ANSWER */}
    <div className="review-section">
      <h3>Correct Sequence</h3>

      <div className="stm-card-container">

        {sequence.map((card, index) => (
          <div
            key={index}
            className={`stm-card ${
              card.suit === "♥" || card.suit === "♦" ? "red" : ""
            }`}
          >
            <div className="card-top">
              {card.rank}{card.suit}
            </div>

            <div className="card-center">
              {card.suit}
            </div>

            <div className="card-bottom">
              {card.rank}{card.suit}
            </div>
          </div>
        ))}

      </div>
    </div>

    <button
      className="go-result-btn"
      onClick={() => finishGame(level - 1, allResults)}
    >
      Go to Result Page
    </button>

  </div>
)}
      {/* ================= RESULT ================= */}
      {page === "result" && (

        <div className="result-big-container">

          <div className="leaderboard-box">
            <h3>Leaderboard</h3>

            <table>
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Name</th>
                  <th>Level</th>
                  <th>Medal</th>
                </tr>
              </thead>

              <tbody>
                {leaderboard.slice(0, 5).map((p, i) => {

                  let medal = "";

                  if (p.rank === 1) {
                    medal = "🥇";
                  } else if (p.rank === 2) {
                    medal = "🥈";
                  } else if (p.rank === 3) {
                    medal = "🥉";
                  }

                  return (
                    <tr key={i}>
                      <td>{p.rank}</td>
                      <td>{p.name}</td>
                      <td>{p.level}</td>
                      <td>{medal}</td>
                    </tr>
                  );

                })}
              </tbody>
            </table>

            {userRank && (
              <div className="your-rank-box">
                Rank: {userRank.rank} <br/>
                Level: {Math.max(0, level - 1)}<br/>
                
              </div>
            )}
          </div>
          

          <div className="results-box">
            <h2>Your Result</h2>
            <p>Level Reached: {Math.max(0, level - 1)}</p>

            <button onClick={() => window.location.reload()}>
              Try Again
            </button>

            <button onClick={() => navigate("/dashboard-login")}>
              Exit
            </button>
          </div>

        </div>

      )}

    </div>
  );
};

export default ShortTermMemoryGame;